export default __webpack_public_path__ + "static/media/Note-Taker-img-2.32469b7e.gif";